import { Link } from "@inertiajs/react";
import Callout from "@/components/help/Callout";

export default function LeaderboardsAndPrivacy() {
  return (
    <>
      <p>
        Read-a-thons are a little public by nature — donations show up on a page you share with family. Our approach is to show only what's needed to get a donation and hide everything else. Here's exactly who can see what.
      </p>

      <h2>Your child's donation page</h2>
      <p>
        The page family donates from. Its address is a long random web link — only people you share it with can find it. (Strangers can't guess at it; pagepledge.com/p/sarah-thompson, for instance, just doesn't work.)
      </p>
      <p>
        On the page, donors see your child's first name and last initial, classroom, grade, and school, along with how much they've raised and how many minutes they've read. They'll also see the school's overall progress, the rewards everyone's chasing, and the list of donations (with the donor's name, the amount, and a message if they left one).
      </p>
      <p>
        What's <strong>not</strong> on the page: photos, ages, addresses, contact info, your child's email, your name, your contact info, or the activation code.
      </p>

      <h2>Who sees what on the leaderboards</h2>
      <p>
        It depends on who's looking. Family members who land on your child's donation page only see classroom-level totals — no other student names. Other parents at the school, when they sign in, see the full leaderboard for their classroom and yours (because their child's name shows on yours, and vice versa). Teachers see the students in their own classrooms by name; admins see everyone.
      </p>

      <h2>Sharing safely</h2>
      <p>
        Family group chats, direct messages, and email are ideal — the audience is limited and the link doesn't get crawled by anything. Private social groups (a family Facebook group, a WhatsApp chat) are fine too. We'd skip public social media posts; once a link is public, anyone can land on the page, including scammers scraping for fundraising opportunities.
      </p>

      <Callout variant="warning" title="If a code or link got out somewhere it shouldn't have">
        <p>
          Ask your child's teacher or school admin to <Link href="/help/articles/rotating-activation-codes">swap the activation code for a new one</Link>. The donation page link is harder to take back, but a new code stops anyone else from signing up to follow your child.
        </p>
      </Callout>

      <h2>Donors can give anonymously</h2>
      <p>
        At checkout, donors can tick a box to keep their name off the page — it'll show as "Anonymous." The school still has their real name in their records (so they can issue a refund if asked), but it never appears anywhere public.
      </p>

      <h2>What the school knows about you</h2>
      <p>
        Your email (so they can reach you), your child's name and classroom, and the reading you've logged. That's it. We don't ask for your address, phone number, or payment information — none of that's needed for the read-a-thon, so we don't collect it.
      </p>

      <p>
        For all the details, see our <Link href="/privacy">privacy policy</Link>. The short version: we're hosted in Canada, we don't run ads, we don't sell anything, and we don't add tracking from outside services.
      </p>

      <h2>What's next</h2>
      <ul>
        <li><Link href="/help/articles/sharing-with-family">Sharing with family</Link>.</li>
        <li><Link href="/help/articles/anonymous-donations-and-messages">Anonymous donations and messages</Link>.</li>
      </ul>
    </>
  );
}
